import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { PFE_ICONS } from 'constants/icons';
import { schedulePropTypes } from 'constants/propTypes';

import ActionsDropdown from './ActionsDropdown';
import messages from './ScheduleDetailV2.messages';
import { useEditActionItems } from './useActionItems';

const EditActionsMenu = ({ schedule }) => {
  const intl = useIntl();
  const { items, visible } = useEditActionItems(schedule);

  if (!visible) {
    return null;
  }

  return (
    <ActionsDropdown
      dataCypress="schedule-detail-v2-edit-menu"
      icon={PFE_ICONS.editPencilOutline}
      items={items}
      label={intl.formatMessage(messages.editMenuLabel)}
    />
  );
};

EditActionsMenu.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes),
};

export default EditActionsMenu;
